module.exports = __webpack_public_path__ + "img/askar.7e74d251.png";